import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LocalCsvService } from '../../../../../services/local-csv/local-csv.service';

@Component({
  selector: 'map-csv-columns',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './map-csv-columns.component.html',
  styleUrl: './map-csv-columns.component.css',
})
export class MapCsvColumnsComponent implements OnInit {
  localCSVService = inject(LocalCsvService);

  selectedPhoneColumn: string = '';

  get headers(): string[] {
    return this.localCSVService.getTableHeaders;
  }

  get previewRows(): string[][] {
    return this.localCSVService.getTableData.slice(0, 3);
  }

  ngOnInit() {
    const phoneKeywords = [
      'phone',
      'phonenumber',
      'phone_number',
      'mobile',
      'telephone',
      'tel',
      'contact',
      'number',
      'msisdn',
    ];
    const match = this.headers.find((h) =>
      phoneKeywords.some(
        (kw) => h.toLowerCase().replace(/[\s_\-]/g, '') === kw
      )
    );
    this.selectedPhoneColumn = match ?? this.headers[0] ?? '';
    this.updateMapping();
  }

  updateMapping() {
    this.localCSVService.updateColumnMapping({
      phoneNumber: this.selectedPhoneColumn,
    });
  }
}
